import React from "react";
import "./Sitemap.css";

const Sitemap = () => {
  return (
    <div className="sitemap_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur
        corrupti voluptas excepturi facilis repellat, temporibus sit vel
        officia, necessitatibus laborum et eligendi! Possimus ut, neque vel
        illum deserunt quas quidem.
      </h1>
    </div>
  );
};

export default Sitemap;
